var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<textarea dias-richtext ng-attr-id=\"{{ vm.param_id }}\" ng-attr-name=\"{{ vm.param_id }}\" ng-model=\"vm.parameter[vm.key].wert\" class=\"form-control\"></textarea>");;return buf.join("");
}